import {HttpErrorResponse} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {Injectable} from "@angular/core";

@Injectable()
export class CapExceptionMapper {

  constructor(private translateService: TranslateService) {
  }

  private map(error: any): string {
    let message;
    if (error instanceof HttpErrorResponse) {

      switch (error.status) {
        case 0:
          message = this.translateService.instant("VerbindungZumServerNichtMöglich");
          break;
        case 302:
          message = this.translateService.instant("AngefordertenRessourceWurdeNeueUriZugewiesen");
          break;
        default:
          message = this.translateService.instant("DerServerMeldetEinenTechnischenFehler", error);
      }
    } else {
      message = this.translateService.instant("EinTechnischerFehlerIstAufgetreten");
    }
    return message;
  }

  getMessageFrom(error): string {
    return this.map(error);
  }

  getStackFrom(e): string {
    // serverside stack may be in error.error if permission is given
    let status;
    if (!!e.status){
      status = 'Status: ' + e?.status;
    }
    return [e.error, e.message, e.stack, status].filter(function (val) {
      return val;
    }).join('\n');
  }
}
